import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { PageHeader } from '@/components/common/PageHeader';
import { useNotify } from '@/hooks/useNotify';
import type { CanalEnvio } from '@/types/enums';

import { EstablecimientoForm } from '../components/EstablecimientoForm';
import { useCreateEstablecimiento } from '../hooks/useEstablecimientos';
import type { EstablecimientoFormValues } from '../schemas';
import type { EstablecimientoCreate } from '../types';

export function NuevoEstablecimientoPage(): JSX.Element {
  const navigate = useNavigate();
  const notify = useNotify();
  const createMutation = useCreateEstablecimiento();

  async function handleSubmit(values: EstablecimientoFormValues): Promise<void> {
    const fac = values.facturacion;
    const facturacionFilled =
      fac.cuit ||
      fac.razon_social ||
      fac.email_facturacion ||
      fac.telefono_whatsapp_facturacion ||
      fac.envio_factura;

    const payload: EstablecimientoCreate = {
      nombre: values.nombre.trim(),
      firma_ganaderos: values.firma_ganaderos?.trim() || null,
      localidad: values.localidad?.trim() || null,
      uid_profesional_actual: values.uid_profesional_actual,
      facturacion: facturacionFilled
        ? {
            cuit: fac.cuit?.trim() || null,
            razon_social: fac.razon_social?.trim() || null,
            email_facturacion: fac.email_facturacion?.trim() || null,
            telefono_whatsapp_facturacion:
              fac.telefono_whatsapp_facturacion?.trim() || null,
            envio_factura: fac.envio_factura ? (fac.envio_factura as CanalEnvio) : null,
          }
        : null,
      telefonos_contacto: (values.telefonos_contacto ?? [])
        .filter((t) => t.numero.trim())
        .map((t) => ({ numero: t.numero, nombre: t.nombre?.trim() || null })),
    };

    try {
      const created = await createMutation.mutateAsync(payload);
      notify.success(`Establecimiento "${created.nombre}" creado.`);
      navigate('/establecimientos');
    } catch {
      // Error displayed inside the form
    }
  }

  return (
    <>
      <PageHeader
        title="Nuevo establecimiento"
        subtitle="Cargá los datos del establecimiento."
        action={
          <Button
            variant="text"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/establecimientos')}
          >
            Volver
          </Button>
        }
      />

      <Card>
        <CardContent sx={{ p: { xs: 2, sm: 4 } }}>
          <EstablecimientoForm
            mode="create"
            onSubmit={handleSubmit}
            onCancel={() => navigate('/establecimientos')}
            submitLabel="Crear establecimiento"
            submitting={createMutation.isPending}
            error={createMutation.error}
          />
        </CardContent>
      </Card>
    </>
  );
}
